"use client";

import { GLOBALS } from "config";
import Link from "next/link";
import { XLogoIcon } from "./Icons";
import { useToast } from "app/hooks";
import { logError } from "@lib/logger";
import { controlMissionToast } from "@lib/utils";

export default function ShareXButton({
  seriesTitle,
  episodeId,
  seriesHash,
}: {
  seriesTitle: string;
  episodeId?: string;
  seriesHash?: string;
}) {
  const { pushToast } = useToast();
  const shareText = `${seriesTitle} ${GLOBALS.SHARE_HASHTAG} ${GLOBALS.SHARE_USER}`;
  let shareUrl = GLOBALS.HOME_URL;
  if (episodeId) {
    shareUrl = shareUrl + "episodes/" + episodeId;
  } else if (seriesHash) {
    shareUrl = shareUrl + "series/" + seriesHash;
  }
  const handleShare = () => {
    fetch(`/api/series/${seriesHash}/share`, {
      method: "POST",
    })
      .then(async (res) => {
        controlMissionToast((await res.json()).missions, pushToast);
      })
      .catch(() => {
        logError("server error: series share");
      });
  };
  return (
    <Link
      href={`https://x.com/intent/tweet?url=${shareUrl}&text=${encodeURIComponent(
        shareText,
      )}&original_referer=${shareUrl}`}
      target="_blank"
      className="g-share-btn mode-x"
      onClick={() => handleShare()}
    >
      <XLogoIcon size={24} ariaHidden={true} className="g-share-btn-icon" />
    </Link>
  );
}
